import styled from 'styled-components';

const ControlPanel = styled.div`
  width: 450px;
  position: relative;
`;

export const TopContentWrapper = styled.div`
  display: flex;
`;

export const StyledControlPanel = styled(ControlPanel)`
  padding: 20px;
`;

export const BottomContent = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
`;

export const Info = styled.div`
  width: 50%;
  padding: 10px 15px;
  box-sizing: border-box;
  position: relative;
`;

export const InfoHeader = styled.div`
  font-size: 14px;
  color: #47b972;
  padding-bottom: 10px;

  &.right {
    position: absolute;
    right: 20px;
    top: 10px;
    text-align: right;
    margin: 0;
    font-weight: 900;
  }
`;

export const BenefitPlace = styled.div`
  margin: 13px 0 -20px;
`;
